import { Row, Col } from 'antd';
import {
  UserOutlined,
  TeamOutlined,
  DollarOutlined,
  FileTextOutlined,
  WarningOutlined,
  CustomerServiceOutlined,
  RiseOutlined,
} from '@ant-design/icons';
import { PageHeader } from '../../components/common/PageHeader';
import { StatCard } from '../../components/common/StatCard';
import { RevenueChart } from '../../components/charts/RevenueChart';
import { UserGrowthChart } from '../../components/charts/UserGrowthChart';
import { ProcessingChart } from '../../components/charts/ProcessingChart';
import { useDashboardMetrics, useRevenueMetrics, useUserMetrics, useProcessingMetrics } from '../../hooks/useAnalytics';

export function DashboardPage() {
  const { data: metrics, isLoading } = useDashboardMetrics();
  const { data: revenue, isLoading: revenueLoading } = useRevenueMetrics(30);
  const { data: users, isLoading: usersLoading } = useUserMetrics(30);
  const { data: processing, isLoading: processingLoading } = useProcessingMetrics(30);

  return (
    <>
      <PageHeader title="Dashboard" subtitle="Overview of key metrics" />
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <StatCard title="Total Users" value={metrics?.total_users ?? 0} prefix={<UserOutlined />} loading={isLoading} />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <StatCard title="Active Subscriptions" value={metrics?.active_subscriptions ?? 0} prefix={<TeamOutlined />} loading={isLoading} />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <StatCard title="MRR" value={metrics?.mrr_usd ?? 0} prefix={<DollarOutlined />} precision={2} loading={isLoading} valueStyle={{ color: '#3f8600' }} />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <StatCard title="ARR" value={metrics?.arr_usd ?? 0} prefix={<RiseOutlined />} precision={2} loading={isLoading} valueStyle={{ color: '#3f8600' }} />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <StatCard title="Signups Today" value={metrics?.new_signups_today ?? 0} prefix={<UserOutlined />} loading={isLoading} />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <StatCard title="Invoices Processed Today" value={metrics?.invoices_processed_today ?? 0} prefix={<FileTextOutlined />} loading={isLoading} />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <StatCard title="Failed Today" value={metrics?.invoices_failed_today ?? 0} prefix={<WarningOutlined />} loading={isLoading} valueStyle={metrics?.invoices_failed_today ? { color: '#cf1322' } : undefined} />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <StatCard title="Open Tickets" value={metrics?.open_tickets ?? 0} prefix={<CustomerServiceOutlined />} loading={isLoading} />
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <RevenueChart data={Array.isArray(revenue) ? revenue.map((r) => ({ date: r.period, mrr_usd: r.mrr_usd, arr_usd: r.arr_usd })) : []} loading={revenueLoading} />
        </Col>
        <Col xs={24} lg={12}>
          <UserGrowthChart data={Array.isArray(users) ? users.map((u) => ({ date: u.period, new_signups: u.new_signups, churned_users: u.churned_users })) : []} loading={usersLoading} />
        </Col>
        <Col xs={24}>
          <ProcessingChart data={Array.isArray(processing) ? processing : []} loading={processingLoading} />
        </Col>
      </Row>
    </>
  );
}
